import React, { Fragment, useState, useEffect, useContext } from "react";
import {
  fetchManageJobsRequest,
  deleteJobRequest,
  resetJob,
} from "../../../redux/recruiter/manage_jobs/actions";
import {
  changeJobStatusRequest,
  resetJobStatusMessage,
} from "../../../redux/recruiter/change_job_status/actions";
import { Edit2, Trash2, Eye, Copy, Users } from "react-feather";
import { Link } from "react-router-dom";
import Spinner from "../../Common/Spinner";
import makeAnimated from "react-select/animated";
import {
  capitalize,
  formatDate,
  unslugAndCapitalize,
  formatExperienceOutput,
  generateSlug, formatSalaryOutput
} from "../../../Components/Common/CommonFunction";
import styled from "styled-components";
import {
  Col,
  Card,
  CardBody,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  CardHeader,
  Badge,
  Button,
  Form,
  Input,
} from "reactstrap";
import DataTable, { defaultThemes } from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { PreloaderContext } from "../../../_helper/Preloader/PreloaderContext";
import { showToast } from "../../Common/Toast";
import { LOADER_TIMEOUT } from "../../../Constant";
import { showSweetAlert } from "../../Common/SweetAlert";
import { useParams } from "react-router-dom";
import NoDataFound from "../../Common/NoDataFound";
import { customStyles, jobStatusOptions } from "../../../Constant";
import Select from "react-select";
import { FaCalendarAlt } from "react-icons/fa";
import {
  DefinedRange,
  DateRangePicker,
  defaultStaticRanges,
} from "react-date-range";
import {
  addYears,
  startOfYear,
  subDays, startOfToday,
  endOfToday,
} from "date-fns";
import { IoMdCopy } from "react-icons/io";
import { addDays } from "date-fns";
import { AuthContext } from "../../../Auth/AuthContext";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
const ManageJobs = () => {
  const dispatch = useDispatch();
  const { triggerTotalPoints } = useContext(AuthContext);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const { showPreloader } = useContext(PreloaderContext);
  const manageJobsReducerData = useSelector((state) => state.manageJobsReducer);
  const { tab, jobReportType } = useParams();
  const [activeTab, setActiveTab] = useState(() => {
    // return tab && tab.toLowerCase() === "all" ? "ALL" : "ACTIVE";
    return tab ? tab.toUpperCase() : "ACTIVE";
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [datePickerOpen, setDatePickerOpen] = useState(false); // State to manage date picker visibility
  const user_data = JSON.parse(localStorage.getItem("user_data"));

  const options = [
    { value: '', label: 'All Job' },
    { value: 'MY_JOB', label: 'My Job' }
  ];
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(jobReportType && jobReportType.toLowerCase() === "myjob" ? options[1] : options[0]);
  const [reportType, setReportType] = useState(() => {
    return jobReportType && jobReportType.toLowerCase() === "myjob" ? "MY_JOB" : selectedOption.value;
  });



  const locale = {
    localize: {
      month: (monthIndex) => {
        const months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        return months[monthIndex];
      },
      day: (dayIndex) => {
        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        return days[dayIndex];
      },
    },
    formatLong: {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    },
  };
  const [formData, setFormData] = useState({
    dateRange: {
      key: "selection",
      // startDate: startOfYear(new Date()), // Start of current year
      // endDate: endOfToday(), // Today
      startDate: subDays(startOfToday(), 30), // Set start date to 30 days ago
      endDate: startOfToday(), // Set end date to today
      type: "ALL",
    },
  });

  const customStaticRanges = [
    {
      label: "All",
      range: () => ({
        startDate: startOfYear(new Date()), // Start of current year
        endDate: endOfToday(), // Today
        type: "ALL",
      }),
      isSelected(range) {
        const definedRange = this.range();
        return (
          range.type === definedRange.type &&
          range.startDate.getTime() === definedRange.startDate.getTime() &&
          range.endDate.getTime() === definedRange.endDate.getTime()
        );
      },
    },
    {
      label: "Internship",
      range: () => ({
        startDate: startOfYear(new Date()), // Start of current year
        endDate: endOfToday(), // Today
        type: "INTERNSHIP",
      }),
      isSelected(range) {
        const definedRange = this.range();
        return (
          range.type === definedRange.type &&
          range.startDate.getTime() === definedRange.startDate.getTime() &&
          range.endDate.getTime() === definedRange.endDate.getTime()
        );
      },
    },

    ...defaultStaticRanges.map((range) => ({
      ...range,
      range: () => ({
        ...range.range(),
        type: range.label.toUpperCase().replace(/ /g, "_"), // Generate a type from the label
      }),
      isSelected(range) {
        const definedRange = this.range();
        return (
          range.type === definedRange.type &&
          range.startDate.getTime() === definedRange.startDate.getTime() &&
          range.endDate.getTime() === definedRange.endDate.getTime()
        );
      },
    })),
  ];

  const handleDateRangeChange = (ranges) => {
    const { selection } = ranges;
    let selectedType = "CUSTOM"; // Default to CUSTOM

    // Check if the selected range matches any predefined ranges
    for (let range of customStaticRanges) {
      const definedRange = range.range();
      if (
        selection.startDate.getTime() === definedRange.startDate.getTime() &&
        selection.endDate.getTime() === definedRange.endDate.getTime() &&
        selection.type === definedRange.type
      ) {
        selectedType = definedRange.type;
        break;
      }
    }

    setFormData({
      ...formData,
      dateRange: {
        ...selection,
        type: selectedType, // Set the type based on the selected range
      },
    });
    setDatePickerOpen(false); // Close the date picker after selecting a valid date range
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      status: activeTab,
      type: formData.dateRange.type,
      keyword: searchQuery,
      startDate: formData.dateRange.startDate
        ? formData.dateRange.startDate.toISOString()
        : null, // Convert Date objects to strings
      endDate: formData.dateRange.endDate
        ? formData.dateRange.endDate.toISOString()
        : null,
      reportType: reportType, // Include report type in the data
    };
    dispatch(fetchManageJobsRequest(currentPage,
      perPage, data, sortColumn, sortDirection));
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };

  const handleDelete = (job_id) => {
    showSweetAlert("confirm", {
      message:
        "If you delete this job, it will be removed and cannot be restored. Are you sure you want to continue?",
      fun: deleteJob,
      id: job_id,
    });
  };

  const deleteJob = (job_id) => {
    dispatch(deleteJobRequest({ job_id }));
  };

  const tabOptions = [
    {
      value: "ALL",
      label: `ALL (${manageJobsReducerData.data.all_jobs || 0})`,
    },
    {
      value: "UNDER_REVIEW",
      label: `UNDER REVIEW (${manageJobsReducerData.data.under_review_jobs || 0
        })`,
    },
    {
      value: "ON_HOLD",
      label: `ON HOLD (${manageJobsReducerData.data.onhold_jobs || 0})`,
    },
    {
      value: "ACTIVE",
      label: `ACTIVE (${manageJobsReducerData.data.active_jobs || 0})`,
    },
    {
      value: "DRAFT",
      label: `DRAFT (${manageJobsReducerData.data.draft_jobs || 0})`,
    },
    {
      value: "CLOSED",
      label: `CLOSED (${manageJobsReducerData.data.closed_jobs || 0})`,
    },
  ];

  const animatedComponents = makeAnimated();
  const colors = {
    primary: "#007bff",
    primary25: "#cce5ff",
    danger: "#dc3545",
    dangerLight: "#f8d7da",
    approved: "green",
    rejected: "red",
    hold: "orange",
    lightGray: "#f8f9fa",
    darkGray: "#343a40",
  };

  const getColor = (value) => {
    switch (value) {
      case "ACTIVE":
        return colors.approved;
      case "ON_HOLD":
        return colors.hold;
      case "CLOSED":
        return colors.rejected;
      case "UNDER_REVIEW":
        return colors.rejected;
      default:
        return colors.darkGray;
    }
  };

  const customStylesSelect = {
    control: (provided, state) => ({
      ...provided,
      width: "160px",
      borderColor: state.isFocused ? colors.primary : provided.borderColor,
      boxShadow: state.isFocused
        ? `0 0 0 1px ${colors.primary}`
        : provided.boxShadow,
      "&:hover": {
        borderColor: colors.primary,
      },
    }),
    singleValue: (provided, state) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
      color: getColor(state.data.value),
      "&::before": {
        content: '"•"',
        color: getColor(state.data.value),
        marginRight: "8px",
        fontSize: "40px",
        lineHeight: "20px",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
      backgroundColor: state.isSelected
        ? getColor(state.data.value)
        : state.isFocused
          ? colors.primary25
          : colors.lightGray,
      color: state.isSelected || state.isFocused ? "#fff" : colors.darkGray,
      "&:hover": {
        backgroundColor: colors.primary25,
        color: colors.darkGray,
      },
      "&::before": {
        content: '"•"',
        color: getColor(state.data.value),
        marginRight: "8px",
        fontSize: "40px",
        lineHeight: "20px",
      },
    }),
  };
  const handleStatusChange = (jobId, newStatus) => {
    const data = {
      job_id: jobId,
      status: newStatus,
    };

    if (newStatus === "CLOSED") {
      return showSweetAlert("confirm", {
        message:
          "If you close this job, it will not be visible to candidates and you will not be able to activate it again. Do you want to continue?",
        fun: () => dispatch(changeJobStatusRequest(data)),
        id: jobId,
      });
    }

    dispatch(changeJobStatusRequest(data));
  };

  // const tableColumns = [
  //   {
  //     name: "#",
  //     short_column: "job_id",
  //     cell: (row, index) => (currentPage - 1) * perPage + index + 1,
  //     width: "5%",
  //     sortable: true,
  //     center: false,
  //   },
  //   {
  //     name: "Job Title",
  //     short_column: "job_name",
  //     sortable: true,
  //     center: false,
  //     // width: "16%",
  //     cell: (row) =>
  //       row.job_name ? (
  //         <Link
  //           to={`${process.env.PUBLIC_URL}/recruiter/job_details/${generateSlug(
  //             row.job_name,
  //             row.job_location,
  //             formatExperienceOutput(
  //               row.work_experience_min,
  //               row.work_experience_max
  //             ).replace("-", "-to-"),
  //             row.job_id
  //           )}`}
  //           title={"View Job"}
  //         >
  //           {capitalize(row.job_name)}
  //         </Link>
  //       ) : (
  //         "-"
  //       ),
  //   },
  //   {
  //     name: "Location",
  //     short_column: "job_location",
  //     cell: (row) => capitalize(row.job_location) || "-",
  //     sortable: true,
  //     center: false,
  //     //width: "14%",
  //   },
  //   {
  //     name: "Experience",
  //     width: "12%",
  //     cell: (row) => {
  //       const experienceOutput = formatExperienceOutput(
  //         row.work_experience_min,
  //         row.work_experience_max
  //       );
  //       return experienceOutput !== "N/A" ? experienceOutput : "-";
  //     },
  //     sortable: false,
  //     center: true,
  //   },
  //   {
  //     name: "Min CTC (LPA)",
  //     center: true,
  //     sortable: true,
  //     short_column: "salary_min",
  //     width: "8%",
  //     cell: (row) => (
  //       <div style={{ textAlign: "center" }}>
  //         {(row.salary_min && row.salary_min) || "-"}
  //       </div>
  //     ),
  //   },
  //   {
  //     name: "Max CTC (LPA)",
  //     center: true,
  //     sortable: true,
  //     short_column: "salary_max",
  //     width: "8%",
  //     cell: (row) => (
  //       <div style={{ textAlign: "center" }}>
  //         {(row.salary_max && row.salary_max) || "-"}
  //       </div>
  //     ),
  //   },

  //   {
  //     name: "Created At",
  //     short_column: "created_at",
  //     cell: (row) => formatDate(row.created_at) || "-",
  //     sortable: true,
  //     center: false,
  //     width: "13%",
  //   },
  //   {
  //     name: "Applications",
  //     short_column: "applied_candidate_count",
  //     width: "12%",
  //     sortable: true,
  //     center: true,
  //     cell: (row) =>
  //       row.applied_candidate_count ? (
  //         <Link
  //           to={`${process.env.PUBLIC_URL
  //             }/recruiter/job_applications/${generateSlug(
  //               row.job_name,
  //               row.job_location,
  //               formatExperienceOutput(
  //                 row.work_experience_min,
  //                 row.work_experience_max
  //               ).replace("-", "-to-"),
  //               row.job_id
  //             )}`}
  //         >
  //           {row.applied_candidate_count}
  //         </Link>
  //       ) : (
  //         0
  //       ),
  //   },
  //   // {
  //   //   name: "Status",
  //   //   width: "115px",
  //   //   sortable: false,
  //   //   center: true,
  //   //   cell: (row) => (
  //   //     <span className={`badge ${getStatusColor(row.job_status)}`}>
  //   //       {unslugAndCapitalize(row.job_status)}
  //   //     </span>
  //   //   ),
  //   // },
  //   // {
  //   //   name: "Status", // New column
  //   //   width: "17%",
  //   //   sortable: false,
  //   //   center: true,
  //   //   cell: (row) =>
  //   //     row.job_status == "UNDER_REVIEW" ? (
  //   //       <Select
  //   //         components={animatedComponents}
  //   //         className="basic-single"
  //   //         classNamePrefix="select"
  //   //         value={{ value: "UNDER_REVIEW", label: "Under Review" }}
  //   //         onChange={(selectedOption) =>
  //   //           handleStatusChange(row.job_id, selectedOption.value)
  //   //         }
  //   //         options={[{ value: "UNDER_REVIEW", label: "Under Review" }].map(
  //   //           (option) => ({
  //   //             value: option.value,
  //   //             label: option.label,
  //   //           })
  //   //         )}
  //   //         styles={{
  //   //           ...customStylesSelect,
  //   //           menuPortalTarget: document.body, // Render the dropdown menu in the body of the document
  //   //         }}
  //   //         isDisabled={["CLOSED", "UNDER_REVIEW"].includes(row.job_status)} // Disable the entire Select component if status is CLOSED or UNDER_REVIEW
  //   //       />
  //   //     ) : (
  //   //       <Select
  //   //         components={animatedComponents}
  //   //         className="basic-single"
  //   //         classNamePrefix="select"
  //   //         value={jobStatusOptions.find(
  //   //           (option) => option.value === row.job_status
  //   //         )}
  //   //         onChange={(selectedOption) =>
  //   //           handleStatusChange(row.job_id, selectedOption.value)
  //   //         }
  //   //         options={jobStatusOptions.map((option) => ({
  //   //           value: option.value,
  //   //           label: option.label,
  //   //         }))}
  //   //         styles={{
  //   //           ...customStylesSelect,
  //   //           menuPortalTarget: document.body, // Render the dropdown menu in the body of the document
  //   //         }}
  //   //         isDisabled={["CLOSED", "UNDER_REVIEW"].includes(row.job_status)} // Disable the entire Select component if status is CLOSED or UNDER_REVIEW
  //   //       />
  //   //     ),
  //   // },
  //   {
  //     name: "Status", // New column
  //     width: "17%",
  //     sortable: false,
  //     center: true,
  //     cell: (row) => {
  //       // Determine the options based on the job status
  //       let options = jobStatusOptions;
  //       // Remove "DRAFT" if status is "ACTIVE"
  //       if (row.job_status === "ACTIVE") {
  //         options = options.filter(option => option.value !== "DRAFT");
  //       }

  //       // Remove "ON HOLD" if status is "DRAFT"
  //       if (row.job_status === "DRAFT") {
  //         options = options.filter(option => option.value !== "ON_HOLD");
  //       }
  //       return row.job_status === "UNDER_REVIEW" ? (
  //         <Select
  //           components={animatedComponents}
  //           className="basic-single"
  //           classNamePrefix="select"
  //           value={{ value: "UNDER_REVIEW", label: "Under Review" }}
  //           onChange={(selectedOption) =>
  //             handleStatusChange(row.job_id, selectedOption.value)
  //           }
  //           options={[{ value: "UNDER_REVIEW", label: "Under Review" }]}
  //           styles={{
  //             ...customStylesSelect,
  //             menuPortalTarget: document.body, // Render the dropdown menu in the body of the document
  //             menu: (provided) => ({
  //               ...provided,
  //               zIndex: 1, // Ensure the dropdown is above other elements
  //             }),
  //           }}
  //           menuPlacement="bottom" // Ensure the dropdown opens below the select input
  //           isDisabled={["CLOSED", "UNDER_REVIEW"].includes(row.job_status)} // Disable the entire Select component if status is CLOSED or UNDER_REVIEW
  //           isSearchable={false} // Disable typing in the select input
  //         />
  //       ) : (
  //         <Select
  //           components={animatedComponents}
  //           className="basic-single"
  //           classNamePrefix="select"
  //           value={jobStatusOptions.find(
  //             (option) => option.value === row.job_status
  //           )}
  //           onChange={(selectedOption) =>
  //             handleStatusChange(row.job_id, selectedOption.value)
  //           }
  //           options={options.map((option) => ({
  //             value: option.value,
  //             label: option.label,
  //           }))}
  //           styles={{
  //             ...customStylesSelect,
  //             menuPortalTarget: document.body, // Render the dropdown menu in the body of the document
  //             control: (provided) => ({
  //               ...provided,
  //               minHeight: '35px',
  //               fontSize: '14px',
  //             }),
  //             menuPortal: (base) => ({
  //               ...base,
  //               zIndex: 9999, // high zIndex to ensure visibility
  //             }),
  //             menu: (provided) => ({
  //               ...provided,
  //               zIndex: 9999,
  //             }),
  //           }}
  //           menuPlacement="bottom" // Ensure the dropdown opens below the select input
  //           isDisabled={["CLOSED", "UNDER_REVIEW"].includes(row.job_status)} // Disable the entire Select component if status is CLOSED or UNDER_REVIEW
  //           menuPosition="fixed"
  //           menuShouldBlockScroll={true}
  //           menuPortalTarget={document.body}
  //           isSearchable={false} // Disable typing in the select input
  //         />
  //       );
  //     },
  //   },

  //   {
  //     name: "Actions",
  //     cell: (row) => (
  //       <div>
  //         <span>
  //           <Link
  //             to={`${process.env.PUBLIC_URL
  //               }/recruiter/job_details/${generateSlug(
  //                 row.job_name,
  //                 row.job_location,
  //                 formatExperienceOutput(
  //                   row.work_experience_min,
  //                   row.work_experience_max
  //                 ).replace("-", "-to-"),
  //                 row.job_id
  //               )}`}
  //             title={"View Job"}
  //           >
  //             <Eye
  //               size={18}
  //               className="eye-icon"
  //               style={{ marginRight: "7px" }}
  //             />
  //           </Link>
  //           {row.job_status !== "CLOSED" &&
  //             row.job_status !== "UNDER_REVIEW" && (
  //               <Link
  //                 to={`${process.env.PUBLIC_URL}/recruiter/post_job/${row.employment_type === "INTERNSHIP" ? "internship" : "job"
  //                   }/${generateSlug(
  //                     row.job_name,
  //                     row.job_location,
  //                     formatExperienceOutput(
  //                       row.work_experience_min,
  //                       row.work_experience_max
  //                     ).replace("-", "-to-"),
  //                     row.job_id
  //                   )}`}
  //                 title={"Edit Job"}
  //               >
  //                 <Edit2
  //                   size={18}
  //                   className="edit-icon"
  //                   style={{ marginRight: "7px" }}
  //                 />
  //               </Link>
  //             )}
  //           <Link
  //             to={`${process.env.PUBLIC_URL}/recruiter/post_job/${row.employment_type === "INTERNSHIP" ? "internship" : "job"
  //               }/${generateSlug(
  //                 row.job_name,
  //                 row.job_location,
  //                 formatExperienceOutput(
  //                   row.work_experience_min,
  //                   row.work_experience_max
  //                 ).replace("-", "-to-"),
  //                 row.job_id
  //               )}/duplicate`}
  //             title={"Duplicate Job"}
  //           >
  //             <IoMdCopy
  //               size={22}
  //               className="copy-icon"
  //               style={{ marginRight: "7px" }}
  //             />
  //           </Link>
  //           {row.job_status !== "CLOSED" &&
  //             row.job_status !== "UNDER_REVIEW" && (
  //               <Link
  //                 to={`${process.env.PUBLIC_URL
  //                   }/recruiter/job_applications/${generateSlug(
  //                     row.job_name,
  //                     row.job_location,
  //                     formatExperienceOutput(
  //                       row.work_experience_min,
  //                       row.work_experience_max
  //                     ).replace("-", "-to-"),
  //                     row.job_id
  //                   )}`}
  //                 title={"View Job Candidate"}
  //               >
  //                 <Users size={18} className="user-icon" style={{ cursor: "pointer", marginRight: "7px" }} />
  //               </Link>
  //             )}
  //           {row.job_status !== "CLOSED" &&
  //             row.job_status !== "UNDER_REVIEW" && (row.recruiter_id == user_data.recruiter_id) && (
  //               <span title="Delete Job">
  //                 <Trash2
  //                   size={18}
  //                   onClick={() => handleDelete(row.job_id)}
  //                   color="red"
  //                   className="delete-icon"
  //                   style={{ cursor: "pointer", marginRight: "7px" }}
  //                 />
  //               </span>
  //             )}
  //         </span>
  //       </div>
  //     ),
  //     sortable: false,
  //     center: true,
  //     // width: "12%",
  //   },
  // ];

  const tableColumns = [
    {
      name: "#",
      short_column: "job_id",
      cell: (row, index) => (currentPage - 1) * perPage + index + 1,
      width: "60px", // Use a fixed, small width for the index column for consistency
      sortable: true,
    },
    {
      name: "Job Title",
      short_column: "job_name",
      sortable: true,
      grow: 3, // Allow this primary column the most space to grow
      // minWidth: '120px', // Ensure the title doesn't get overly squished on small screens
      cell: (row) =>
        row.job_name ? (
          <Link
            to={`${process.env.PUBLIC_URL}/recruiter/job_details/${generateSlug(
              row.job_name,
              row.job_location,
              formatExperienceOutput(
                row.work_experience_min,
                row.work_experience_max
              ).replace("-", "-to-"),
              row.job_id
            )}`}
            title={"View Job"}
            style={{ overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}
          >
            {capitalize(row.job_name)}
          </Link>
        ) : (
          "-"
        ),
    },
    {
      name: "Location",
      short_column: "job_location",
      sortable: true,
      grow: 2, // Allow more space than standard columns
      minWidth: '110px',
      cell: (row) => capitalize(row.job_location) || "-",
    },
    {
      name: "Experience",
      sortable: false,
      center: true,
      grow: 1,
      minWidth: '120px',
      cell: (row) => {
        const experienceOutput = formatExperienceOutput(
          row.work_experience_min,
          row.work_experience_max
        );
        return experienceOutput !== "N/A" ? experienceOutput : "-";
      },
    },
    {
      name: "Min CTC (LPA)",
      center: true,
      sortable: true,
      short_column: "salary_min",
      grow: 1,
      minWidth: '110px',
      cell: (row) => (
        <div style={{ textAlign: "center" }}>
          {row.salary_min || "-"}
        </div>
      ),
    },
    {
      name: "Max CTC (LPA)",
      center: true,
      sortable: true,
      short_column: "salary_max",
      grow: 1,
      minWidth: '120px',
      cell: (row) => (
        <div style={{ textAlign: "center" }}>
          {row.salary_max || "-"}
        </div>
      ),
    },
    {
      name: "Created At",
      short_column: "created_at",
      sortable: true,
      grow: 1.5,
      minWidth: '130px',
      cell: (row) => formatDate(row.created_at) || "-",
    },
    {
      name: "Posting Type",
      sortable: false,
      center: true,
      grow: 1,
      minWidth: '120px',
      cell: (row) => capitalize(row.posting_type) || "-",
    },
    {
      name: "Employment Type",
      sortable: false,
      center: true,
      grow: 1,
      minWidth: '140px',
      cell: (row) => capitalize(row.employment_type) || "-",
    },
    {
      name: "Applications",
      short_column: "applied_candidate_count",
      sortable: true,
      center: true,
      grow: 1,
      minWidth: '120px',
      cell: (row) =>
        row.applied_candidate_count ? (
          <Link
            to={`${process.env.PUBLIC_URL
              }/recruiter/job_applications/${generateSlug(
                row.job_name,
                row.job_location,
                formatExperienceOutput(
                  row.work_experience_min,
                  row.work_experience_max
                ).replace("-", "-to-"),
                row.job_id
              )}`}
          >
            {row.applied_candidate_count}
          </Link>
        ) : (
          0
        ),
    },
    {
      name: "Status",
      sortable: false,
      center: true,
      grow: 1.5,
      minWidth: '170px', // A generous min-width to ensure the Select component renders well
      cell: (row) => {
        let options = jobStatusOptions;
        if (row.job_status === "ACTIVE") {
          options = options.filter(option => option.value !== "DRAFT");
        }
        if (row.job_status === "DRAFT") {
          options = options.filter(option => option.value !== "ON_HOLD");
        }
        return row.job_status === "UNDER_REVIEW" ? (
          <Select
            components={animatedComponents}
            className="basic-single"
            classNamePrefix="select"
            value={{ value: "UNDER_REVIEW", label: "Under Review" }}
            onChange={(selectedOption) =>
              handleStatusChange(row.job_id, selectedOption.value)
            }
            options={[{ value: "UNDER_REVIEW", label: "Under Review" }]}
            styles={{
              ...customStylesSelect,
              menu: (provided) => ({ ...provided, zIndex: 9999 }),
            }}
            menuPlacement="auto"
            isDisabled={["CLOSED", "UNDER_REVIEW"].includes(row.job_status)}
            isSearchable={false}
            menuPosition="fixed"
            menuPortalTarget={document.body}
          />
        ) : (
          <Select
            components={animatedComponents}
            className="basic-single"
            classNamePrefix="select"
            value={jobStatusOptions.find(
              (option) => option.value === row.job_status
            )}
            onChange={(selectedOption) =>
              handleStatusChange(row.job_id, selectedOption.value)
            }
            options={options.map((option) => ({
              value: option.value,
              label: option.label,
            }))}
            styles={{
              ...customStylesSelect,
              control: (provided) => ({
                ...provided,
                minHeight: '35px',
                fontSize: '14px',
              }),
              menu: (provided) => ({ ...provided, zIndex: 9999 }),
            }}
            menuPlacement="auto"
            isDisabled={["CLOSED", "UNDER_REVIEW"].includes(row.job_status)}
            menuPosition="fixed"
            menuPortalTarget={document.body}
            isSearchable={false}
          />
        );
      },
    },
    {
      name: "Actions",
      sortable: false,
      center: true,
      width: '130px', // Use a fixed width for the Actions column for UI stability
      cell: (row) => (
        <div className="d-flex justify-content-center align-items-center gap-1">
          <Link
            to={`${process.env.PUBLIC_URL
              }/recruiter/job_details/${generateSlug(
                row.job_name,
                row.job_location,
                formatExperienceOutput(
                  row.work_experience_min,
                  row.work_experience_max
                ).replace("-", "-to-"),
                row.job_id
              )}`}
            title={"View Job"}
          >
            <Eye
              size={18}
              className="eye-icon"
            />
          </Link>
          {row.job_status !== "CLOSED" &&
            row.job_status !== "UNDER_REVIEW" && (
              <Link
                to={`${process.env.PUBLIC_URL}/recruiter/post_job/${row.employment_type === "INTERNSHIP" ? "internship" : "job"
                  }/${generateSlug(
                    row.job_name,
                    row.job_location,
                    formatExperienceOutput(
                      row.work_experience_min,
                      row.work_experience_max
                    ).replace("-", "-to-"),
                    row.job_id
                  )}`}
                title={"Edit Job"}
              >
                <Edit2
                  size={18}
                  className="edit-icon"
                />
              </Link>
            )}
          <Link
            to={`${process.env.PUBLIC_URL}/recruiter/post_job/${row.employment_type === "INTERNSHIP" ? "internship" : "job"
              }/${generateSlug(
                row.job_name,
                row.job_location,
                formatExperienceOutput(
                  row.work_experience_min,
                  row.work_experience_max
                ).replace("-", "-to-"),
                row.job_id
              )}/duplicate`}
            title={"Duplicate Job"}
          >
            <IoMdCopy
              size={22}
              className="copy-icon"
            />
          </Link>
          {row.job_status !== "CLOSED" &&
            row.job_status !== "UNDER_REVIEW" && (
              <Link
                to={`${process.env.PUBLIC_URL
                  }/recruiter/job_applications/${generateSlug(
                    row.job_name,
                    row.job_location,
                    formatExperienceOutput(
                      row.work_experience_min,
                      row.work_experience_max
                    ).replace("-", "-to-"),
                    row.job_id
                  )}`}
                title={"View Job Candidate"}
              >
                <Users size={18} className="user-icon" style={{ cursor: "pointer" }} />
              </Link>
            )}
          {row.job_status !== "CLOSED" &&
            row.job_status !== "UNDER_REVIEW" && (row.recruiter_id === user_data.recruiter_id) && (
              <span title="Delete Job">
                <Trash2
                  size={18}
                  onClick={() => handleDelete(row.job_id)}
                  color="red"
                  className="delete-icon"
                  style={{ cursor: "pointer" }}
                />
              </span>
            )}
        </div>
      ),
    },
  ];

  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");

  useEffect(() => {
    console.log("currentPages", currentPage);
    fetchJobs();
  }, [activeTab, perPage, currentPage, formData, sortColumn, sortDirection, reportType]);

  const fetchJobs = () => {
    const data = {
      type: formData.dateRange.type,
      status: activeTab,
      keyword: searchQuery,
      startDate: formData.dateRange.startDate
        ? formData.dateRange.startDate.toISOString()
        : null, // Convert Date objects to strings
      endDate: formData.dateRange.endDate
        ? formData.dateRange.endDate.toISOString()
        : null,
      reportType: reportType
    };
    dispatch(fetchManageJobsRequest(currentPage,
      perPage, data, sortColumn, sortDirection));
  }

  const handleSort = async (column, direction) => {
    setSortColumn(column.short_column);
    setSortDirection(direction);
    // fetchJobs(); // Fetch jobs with new sorting

  };



  const manageJobsData = manageJobsReducerData.data.data;

  // code to show toast message
  useEffect(() => {
    if (manageJobsReducerData.status && manageJobsReducerData.message != "") {
      showToast("success", manageJobsReducerData.message);

      const data = {
        status: activeTab,
        type: formData.dateRange.type,
        keyword: searchQuery,
        startDate: formData.dateRange.startDate
          ? formData.dateRange.startDate.toISOString()
          : null, // Convert Date objects to strings
        endDate: formData.dateRange.endDate
          ? formData.dateRange.endDate.toISOString()
          : null,
        reportType: reportType
      };
      dispatch(fetchManageJobsRequest(currentPage,
        perPage, data, sortColumn, sortDirection));
      dispatch(resetJob());
    } else if (
      manageJobsReducerData.status == false &&
      manageJobsReducerData.message != ""
    ) {
      if (showPreloader) {
        setTimeout(() => {
          showToast("error", manageJobsReducerData.message);
        }, LOADER_TIMEOUT);
      } else {
        showToast("error", manageJobsReducerData.message);
      }
      dispatch(resetJob());
    }
  }, [manageJobsReducerData, reportType]);

  const changeJobStatusReducerData = useSelector(
    (state) => state.changeJobStatusReducer
  );
  useEffect(() => {
    const { status, message, data: statusData } = changeJobStatusReducerData;
    if (
      status &&
      message != ""
    ) {

      console.log("manageJobsReducerData", manageJobsReducerData);
      showToast("success", message);

      const jobId = statusData?.job_id;
      const jobStatus = statusData?.status;
      const jobList = Array.isArray(manageJobsReducerData?.data?.data)
        ? manageJobsReducerData.data.data
        : [];

      const jobData = jobList.find((job) => job.job_id === jobId);
      console.log("jobData", jobData);
      if (jobData && jobStatus === "ACTIVE" && jobData.posting_type === "EXTERNAL" && jobData.job_status !== "ON_HOLD") {
        triggerTotalPoints("post_jobs", false);
      }
      const data = {
        status: activeTab,
        type: formData.dateRange.type,
        keyword: searchQuery,
        startDate: formData.dateRange.startDate
          ? formData.dateRange.startDate.toISOString()
          : null, // Convert Date objects to strings
        endDate: formData.dateRange.endDate
          ? formData.dateRange.endDate.toISOString()
          : null,
        reportType: reportType
      };
      dispatch(fetchManageJobsRequest(currentPage,
        perPage, data, sortColumn, sortDirection));
      dispatch(resetJobStatusMessage());
    } else if (
      changeJobStatusReducerData.status == false &&
      changeJobStatusReducerData.message != ""
    ) {
      if (showPreloader) {
        setTimeout(() => {
          showToast("error", changeJobStatusReducerData.message);
        }, LOADER_TIMEOUT);
      } else {
        showToast("error", changeJobStatusReducerData.message);
      }
      dispatch(resetJobStatusMessage());
    }
  }, [changeJobStatusReducerData, reportType]);




  const toggleDropdown = () => setDropdownOpen(prev => !prev);

  const handleSelect = (value) => {
    const selected = options.find(opt => opt.value === value);
    if (selected) {
      setSelectedOption(selected);
      setReportType(selected.value); // Update report type state
    }
    // Delay closing the dropdown to avoid event interference
    setTimeout(() => setDropdownOpen(false), 0);
  };


  return (
    <Fragment>
      <Row>
        <Col xs="12" className="box-col-12 xl-100">
          <Card>
            <CardHeader className="py-3">

              <div className="d-flex flex-wrap justify-content-between align-items-end mb-3">
                {/* Search Bar */}

                <Form
                  className="theme-form me-2 flex-grow-1"
                  onSubmit={handleSubmit}
                >
                  <div
                    className="input-group flex-nowrap "
                    style={{ height: 35, maxWidth: "350px" }}
                  >
                    <Input
                      className="form-control"
                      value={searchQuery}
                      onChange={handleSearchChange}
                      type="search"
                      placeholder="Search.."
                    />
                    <Button
                      color="primary"
                      type="submit"
                      className="btn-primary input-group-text pe-3 ps-3"
                    >
                      Search
                    </Button>
                  </div>
                </Form>

                {/* Date Picker Button */}
                <div className="d-flex align-items-center ms-auto mt-3 mt-md-0">
                  <div className="dropdown-basic">
                    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} autoClose="inside" className="dropdown">
                      <Button
                        color="primary"
                        onClick={toggleDropdown}
                        className="d-flex align-items-center me-2"
                        aria-haspopup="true"
                        aria-expanded={dropdownOpen}
                      >
                        {selectedOption.label}
                        <span className="ms-2"><i className="icofont icofont-arrow-down"></i></span>
                      </Button>
                      <DropdownMenu className="dropdown-content custom-dropdown">
                        {options.map((item, i) => (
                          <DropdownItem key={i} onClick={() => handleSelect(item.value)}>
                            {item.label}
                          </DropdownItem>
                        ))}
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                  <Button
                    color="primary"
                    id="shownCalendar"
                    onClick={() => setDatePickerOpen(!datePickerOpen)}
                    className="btn btn-primary d-flex align-items-center ps-3 pe-3"
                  >
                    <FaCalendarAlt className="" />
                    <span className="ms-2">
                      {formData &&
                        (formData.dateRange.type === "CUSTOM"
                          ? `${formatDate(
                            formData.dateRange.startDate,
                            "dd-MM-yyyy"
                          )} - ${formatDate(
                            formData.dateRange.endDate,
                            "dd-MM-yyyy"
                          )}`
                          : unslugAndCapitalize(formData.dateRange.type))}
                    </span>
                  </Button>
                  {datePickerOpen && (
                    <div
                      style={{
                        position: "absolute",
                        top: "50px", // Adjust as needed based on your layout
                        right: "0",
                        zIndex: 1000,
                      }}
                    >
                      {/* <DefinedRange
                          onChange={handleDateRangeChange}
                          ranges={[formData.dateRange]}
                          open={datePickerOpen}
                        /> */}
                      <DateRangePicker
                        editableDateInputs
                        onChange={handleDateRangeChange}
                        ranges={[formData.dateRange]}
                        locale={locale}
                        // months={2}
                        direction="horizontal"
                        open={datePickerOpen}
                        onToggle={(open) => setDatePickerOpen(open)}
                        staticRanges={customStaticRanges}
                      />
                    </div>
                  )}
                </div>
              </div>
              <Nav
                className="nav-pills nav-primary justify-content-between"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                {tabOptions.map((item, i) => (
                  <NavItem key={i}>
                    <NavLink
                      className={`font-weight-bold ${activeTab === item.value ? "active" : ""
                        }`}
                      onClick={() => setActiveTab(item.value)}
                      style={{ cursor: "pointer" }}
                    >
                      {item.label}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>
            </CardHeader>

            <CardBody className="px-0 py-3">
              <div className="tabbed-card">
                <TabContent activeTab={activeTab}>
                  <TabPane tabId={activeTab}>

                    <div className="table-container">
                      <DataTable
                        responsive
                        customStyles={customStyles}
                        data={manageJobsData}
                        columns={tableColumns}
                        striped={true}
                        center={true}
                        pagination
                        paginationServer
                        paginationTotalRows={manageJobsReducerData.data.total}
                        paginationPerPage={perPage}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                        progressPending={manageJobsReducerData.isLoading}
                        progressComponent={<Spinner />}
                        noDataComponent={
                          <NoDataFound message={"No jobs found"} />
                        }
                        onSort={(column, direction) =>
                          handleSort(column, direction)
                        }
                      />
                    </div>
                  </TabPane>
                </TabContent>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Fragment >
  );
};

export default ManageJobs;
